import { ref } from 'vue'
import { useApi } from './useApi.js'

// A teacher's open lesson requests as calendar ghosts: every time on their Signups
// tab (/api/teacher-signups) that's still live — requested, family-suggested, or
// one they offered and the family hasn't answered. Clicking one opens that signup's
// TeacherSignupCard, so confirm / suggest / decline are exactly the tab's.
// Booked times aren't here: once confirmed, the invite ghost (`…-ghosts`) takes over.
const LIVE_KINDS = ['requested', 'family_suggested', 'you_offered']

export function useRequestGhosts() {
  const { fetchApi } = useApi()
  const requestGhosts = ref([])

  const fetchRequests = async teacherName => {
    const data = await fetchApi('/api/teacher-signups?view=open').catch(() => null)
    requestGhosts.value = (data?.signups || []).flatMap(signup => signup.slots
      .filter(t => LIVE_KINDS.includes(t.kind) && !t.superseded && t.date && t.time)
      .map(t => ({
        id: `request-${signup.id}-${t.date}-${t.time}`,
        request: true,
        kind: t.kind,
        signup,
        teacher_name: teacherName,
        lesson_date: t.date,
        lesson_time: t.time,
        duration_minutes: t.duration_minutes || 30,
        student_name: signup.student_name,
        instrument: signup.instrument,
        age: signup.age,
      })))
  }

  return { requestGhosts, fetchRequests }
}
